export default __webpack_public_path__ + "static/media/placeholder.552a2d59.svg";